<template>
    <div id="app" class="newyear-2021-theme">
        <vue-topprogress ref="topProgress" color="#da1831" :minimum="70" :speed="200" id="topProgress"></vue-topprogress>
        <div class="wrapper">
            <div class="wrapper-in">
                <salesModal></salesModal>
                <BanerTopVertical :options="[{page: 'home'}]" v-if="banerSystem != undefined && banerSystem.baner_system_active == 'true'"></BanerTopVertical>
                <AppHeader :class="{'banerOnline' : banerSystem != undefined && banerSystem.baner_system_active == 'true' && banerTopCoockieVisible == true}"></AppHeader>
                <mobileSidebar v-if="iSmobile" :class="{'banerOnline' : banerSystem != undefined && banerSystem.baner_system_active == 'true' && banerTopCoockieVisible == true}"></mobileSidebar>
                <main class="content" id="content-layout" :class="{'banerOnline' : banerSystem != undefined && banerSystem.baner_system_active == 'true' && banerTopCoockieVisible == true}">
                    <transition name="fade" mode="out-in">
                        <router-view v-cloak/>
                    </transition>
                </main>
                <formBazisClub></formBazisClub>
                <formConsult></formConsult>
                <AppFooter></AppFooter>
                <transition name="fade" mode="out-in">
                    <div class="body-overlay" id="body-overlay" @click="closeMobileMenu(!openSendwich)" v-cloak v-if="openSendwich || openFormConsult || openFormBazis || overlayTrue || openSalesModal" :class="{'openFormConsult': openFormConsult, 'openSalesModal' : openSalesModal}"></div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    // import breadcrumbs from '@/components/breadcrumbs/breadcrumbs.vue'
    // import hotBtns from '@/components/secret-btns/hot-btns.vue'
    // import firebase from 'firebase'
    import AppHeader from '@/components/header/header.vue'
    import AppFooter from '@/components/footer/footer.vue'
    import mobileSidebar from '@/components/mobile-sidebar/mobile-sidebar.vue'
    import salesModal from '@/components/partials/sales-modal.vue'
    import formConsult from '@/components/forms/form-consult.vue'
    import formBazisClub from '@/components/forms/form-bazis-club.vue'
    import formCovid from '@/components/forms/form-covid.vue'
    // import banerOnline from '@/components/baner-system/baner-online.vue'
    import BanerTopVertical from '@/components/baner-system/baner-top-vertical.vue'
    import {mapGetters} from 'vuex'
    export default {
        components: {
            AppHeader,
            AppFooter,
            mobileSidebar,
            formConsult,
            formBazisClub,
            formCovid,
            salesModal,
            // banerOnline,
            BanerTopVertical,
            // breadcrumbs,
            // hotBtns,
        },
        data () {
            return {
                iSmobile: false,
                title: '',
                overlayTrue: false,
                amount: 75,
                size: 20,
            }
        },
        computed: mapGetters({
            openSendwich: 'loadOpenSendwich',
            openFormConsult: 'loadOpenFormConsult',
            openFormBazis: 'loadOpenFormBazis',
            openSalesModal: 'loadSalesModalAction',
            banerSystem: 'loadBanerSystem',
            banerTopCoockieVisible: 'loadCockieBanerTopVisible',
            // openGlobal: 'loadGlobalOpen',
            // openNotifMenu: 'loadOpenNotifyMenu',
            // addClassContent: 'loadADDclassToContent',
        }),
        methods: {
            // isMobileCheck() {
            //     var checkMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            //     if (checkMobile) {
            //         this.isMobile = true
            //     }
            // },
            initSupportPage() {
                this.$router.push({name: 'support'});
            },
            enableInterceptor() {
                this.axiosInterceptor = window.axios.interceptors.request.use((config) => {
                    this.$refs.topProgress.start();
                    return config
                }, (error) => {
                    this.$refs.topProgress.fail();
                    return Promise.reject(error)
                })
                
                window.axios.interceptors.response.use((response) => {
                    this.$refs.topProgress.done();
                    return response
                }, function(error) {
                    this.$refs.topProgress.fail();
                    return Promise.reject(error)
                })
            },
            closeMobileMenu(data) {
                this.overlayTrue = false;
                this.$store.commit('Open_Sendwich', false);
                this.$store.commit('Open_form_Consult', false);
                this.$store.commit('openSalesModalAction', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                document.getElementsByTagName('body')[0].classList.remove('overlay-open-sales-modal');
            },
            disableInterceptor() {
                window.axios.interceptors.request.eject(this.axiosInterceptor)
            },     
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                } else {
                    this.iSmobile = false
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
            setCockieBanerTop() {
                var cockie = this.$cookie.get('baner_top_visible');
                // console.log(cockie, 'cockie test')
                if (this.banerSystem != null && this.banerSystem.baner_system_active == 'true' && cockie == null) {
                    this.$cookie.set('baner_top_visible', true, { expires: '1D' });
                    this.$store.commit('coockieBanerTopVisible', true);
                    // console.log(cockie, 'first_step')
                } else if (this.banerSystem != null && this.banerSystem.baner_system_active == 'true' && cockie == 'true') {
                    this.$store.commit('coockieBanerTopVisible', true);
                    // this.$cookie.set('baner_top_visible', true, { expires: '1D' });
                    // console.log(cockie, 'first_second')
                } else if (this.banerSystem != null && this.banerSystem.baner_system_active == 'true' && cockie == 'false') {
                    // this.$store.commit('coockieBanerTopVisible', true);
                    // console.log(cockie, 'first_third');
                } else {
                    return false;
                }
            },
            checkActionsInURL() {
                var action = window.location
                var param = new URL(window.location.href).searchParams.get('urlAction');
                var cockie = this.$cookie.get('summerSalesModal');
                // && cockie == null
                if (param != null && param == 'summer_sales') {
                    this.$store.commit('openSalesModalAction', true);
                    document.getElementsByTagName('body')[0].classList.add('overlay-open-sales-modal');
                } else {
                    this.$store.commit('openSalesModalAction', false);
                    document.getElementsByTagName('body')[0].classList.remove('overlay-open-sales-modal');
                }
            }
        },
        beforeCreate() {
            if (localStorage.getItem('language') === null) {
                localStorage.setItem('language', '');
            }

            this.$store.dispatch('getFullSetUpProject').then((response) => {
                // console.log(response, 'HOME')
                this.setCockieBanerTop();
            });
            // this.$store.dispatch('getPageSetUp');
            // this.$store.dispatch('getBanerSystem');
        },
        created () {
        },
        mounted () {
            this.$refs.topProgress.start();
            this.isMobileCheck();
            this.checkResize();
            this.checkActionsInURL();
            // this.enableInterceptor();
        }
    }
</script>